export class DrillDownInformation {
  name: string;
  category: string;
  group: string;
  information: any;
}
